<template>
  <div class="editAdd">
    <img v-if="$route.query.type == 'meeting'" src="/static/images/meeting/addadd-title.png">
    <article>
      <div class="top_map" v-if="isweixin">
        <div class="top_div" v-if="isApply">
          <div class="lf_txt"><img src="../../assets/images/addressMap.png">{{defAddress}}</div>
           <button class="btn_top" @click="startSite">定位</button>
        </div>
        <div class="top_div" v-else>
          <img style="width: 18px;height: 18px;margin-right: 3px;margin-top: 2px;" src="../../assets/images/addressMap.png">
          <div class="lf_txt" style="flex-direction: column;width: 100%;">
            <div style="padding-right: 5px;">{{siteAddress}}</div>
            <div style="font-weight: 500;">{{sitepcq}}</div>
          </div>
           <button class="btn_top" @click="startSite">定位</button>
        </div>
      </div>
      <ul>
        <li>
          <p>收货人：</p>
          <input type="text" placeholder="请使用真实姓名" maxlength="15" v-model="addressValue.name" @input="handlechange('name')"/>
        </li>
        <li>
          <p>联系方式：</p>
          <input
            type="tel"
            :maxlength="number"
            id="code"
            name="code"
            minlength="7"
            v-model="mobile"
            placeholder="请输入手机号码"
            @keyup="handleInput($event)"
            class="input-code"
            ref="input">
        </li>
        <li @click="regionClick">
          <p>所在地区：</p>
          <div>
            <span style="color: #b7b7b7;font-size: 0.14rem;" v-if="addressValue.area==''">请选择省市区</span>
            <span style="font-size: 0.14rem;color: #333;" v-else>{{addressValue.area}}</span>
          </div>
           <img src="../../assets/images/jt3.png">
        </li>
        <li>
          <p style="height:60px;">详细地址：</p>
          <textarea
            v-model="addressValue.address"
            placeholder="请输入街道、门牌号码等"
            name=""
            maxlength="42"
            @blur="input_blur"
            @input="handlechange('address')"
            id="addressText"
          ></textarea>
        </li>
      </ul>
       <div class="bottom_div">
          <textarea
            v-model="smartTxt"
            placeholder="粘贴文本，可自动识别姓名、电话和地址。例如：陕西省西安市长安区xx街道xx路xx号，李梅，184****6540"
            name=""
            maxlength="60"
            @blur="input_blur"
            id="addressText"
          ></textarea>
          <div class="btn_div">
            <span v-if="smartTxt!=''" class="btn_rt1" @click="clearSmart">清空</span>
            <button v-if="smartTxt==''" class="btn_rt2">开始识别</button>
            <button @click="discern(1, smartTxt)" class="btn_rt3" v-else>开始识别</button>
          </div>

        </div>
    </article>
    <awesome-picker
      v-if="regionShow"
      ref="pickerRegion"
      :textTitle="pickerRegion.textTitle"
      :data="pickerRegion.data"
      :anchor="pickerRegion.anchor"
      @confirm="handlePickerConfirmRegion">
    </awesome-picker>
    <footer class="footerIOS">
      <button v-if="addressValue.name==''||addressValue.mobile==''||addressValue.area==''||addressValue.address==''" class="btn btn_dis">{{$route.query.type == 'meeting' ? '保存并使用' : '保存'}}</button>
      <button v-else class="btn" @click="submit">{{$route.query.type == 'meeting' ? '保存并使用' : '保存'}}</button>
    </footer>
    <div v-if="showMap">
    <van-popup v-model="showMap" position="right" :style="{ height: '100%',width:'100%' }">
            <qq-map :map-key="mapKey" :key-name="keyName" :lat="latVal" :lng="lngVal" @callback="callback" @hideMap="showMap=false"></qq-map>
        </van-popup>
        </div>
    <van-overlay :custom-style="{'background': 'rgba(0, 0, 0, 0)'}" :show="overlayshow" />
    <van-dialog
      :cancel-button-color="'#FC0324'"
      :cancel-button-text="'不修改 直接保存'"
      :confirm-button-color="'#ffffff'"
      :confirm-button-text="'修改并保存'"
      :show-cancel-button="true"
      @cancel="notUpdateHandle"
      @confirm="updateHandle"
      class="collect_button_alert"
      title=""
      v-model="discernshow"
    >
      <div class="discern">
        <p class="f15">所在地区不准会影响物流配送</p>
        <p class="f15">自动识别到您所在的地区为：</p>
        <span class="f15 color-FC0324">{{areatemp}}</span>
        <p class="f15">是否修改？</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { isWeixin, fenxiang, isApp, discernFunc } from "../../assets/common/js/config";
import wx from "weixin-js-sdk";
import QqMap from "../common/Qqmap.vue";

export default {
  name: "addAddress",
  components: {
    QqMap
  },
  data() {
    return {
      number: 14,
      mobile: "",
      addressValue: {
        name: "",
        mobile: "",
        area: "",
        addressid: "",
        address: "",
        isdefault: "0"
      },
      smartTxt: "",
      pickerRegion: {
        anchor: [],
        textTitle: "区域选择器",
        data: []
      },
      showMap: false,
      mapKey: "526BZ-5VR6U-26ZVZ-42EA5-66IWZ-UFBX5",
      keyName: "mysite",
      latVal: "",
      lngVal: "",
      sitepcq: "",
      defAddress: "点击定位获取当前收货地址",
      siteAddress: "点击重新定位选择收货地址",
      isApply: true,
      isweixin: isWeixin(),
      overlayshow: false,
      addressid: '',
      discernshow: false,
      regionShow: true,
      areatemp: '',
      areaidtemp: ''
    };
  },
  mounted: function() {
    localStorage.removeItem('resSite')
    if (isWeixin()) {
      fenxiang({ path: "addaddress" });
    }
    if (this.$route.query.type == 'meeting') this.getAddress()
    this.getData();
    this.setMapShow();
    this.getLocationSite()
  },
  destroyed: function() {
    this.$toast.clear();
    this.$dialog.close();
  },
  watch: {
    mobile(n) {
      // this.addressValue.mobile = n
      this.$nextTick(() => {
        //这里
        this.mobile = String(n).replace(/\D/g, "");
        this.addressValue.mobile = this.mobile;
        console.log(this.addressValue.mobile);
      });
    }
  },
  methods: {
    getLocationSite(){
      let site = localStorage.getItem('resSite')
      if(site){
        this.discern(2, site)
      }
    },
    setMapShow() {
      if (localStorage.getItem("goMap") == "1") {
        this.isApply = false;
      } else {
        this.isApply = true;
      }
    },
    getAddress () {
      var checkurl = this.$ajax.checkGetMeetingsPrizes_URL, that = this
      that.$customRequestAjax(checkurl).then(res => {
        if (res.data.addressid) {
          that.addressid = res.data.addressid ? res.data.addressid : ''
          var urlOldAdd = that.$ajax.getAddressById_URL+'?id=' + res.data.addressid
          that.$customRequestAjax(urlOldAdd).then(res => {
            if (res.data.code === 200) {
              that.addressValue = res.data.addressdata
              that.mobile = that.addressValue.mobile
            }
          })
        }
        if (res.data.code == 200) {
          if (res.data.isaddwx == 0) {
            that.overlayshow = true
            that.$dialog.alert({
              message: res.data.msg,
              className: 'percen_button_alert',
              confirmButtonColor: '#FFFCFC',
              confirmButtonText: '去领取',
              closeOnPopstate: false
            }).then(function () {
              // on confirm
              window.location = '/static/wx/html/meeting/erweima.html'
            })
          } else {
            that.overlayshow = false
          }
        } else if (res.data.code == 2001) {
          that.overlayshow = true
          that.$dialog.alert({
            message: res.data.msg,
            className: 'percen_button_alert',
            confirmButtonColor: '#FFFCFC',
            confirmButtonText: '我知道了',
            closeOnPopstate: false
          }).then(function () {
            // on confirm
            if (res.data.meetingid) {
              window.location.replace('/static/wx/html/meeting/exclusive-gift.html?meetingid=' + res.data.meetingid)
            } else {
              that.$router.replace('/')
            }
          })
        } else {
          that.overlayshow = true
          that.$toast(res.data.msg)
        }
      })

    },
    // 地图选择回调
    callback(mapData) {
      this.showMap = false;
      this.setMapShow();
      if (typeof mapData.poiaddress == "undefined") {
        return;
      }
      let siteName = mapData.poiaddress;
      localStorage.setItem('resSite',siteName)
      this.discern(1, siteName);
    },
    getData: function() {
      var url = this.$ajax.getArea_URL;
      var that = this;
      that.$customRequestAjax(url).then(res => {
        if (res.data.code === 200) {
          that.pickerRegion.data = res.data.data;
          that.pickerRegion.data.forEach(item => {
            item["value"] = item.name;
            delete item["name"];
            item["children"] = item.child;
            delete item["child"];
            item.children.forEach(itemSon => {
              itemSon["province"] = item.value;
              itemSon["value"] = itemSon.name;
              delete itemSon["name"];
              itemSon["children"] = itemSon.child;
              delete itemSon["child"];
              itemSon.children.forEach(itemGrandson => {
                itemGrandson["value"] = itemGrandson.name;
                delete itemGrandson["name"];
                itemGrandson["city"] = itemSon.value;
              });
            });
          });
          that.pickerRegion.data = res.data.data;
        }
      });
    },
    handleInput(e) {
      this.$refs.input.value = this.addressValue.mobile;
      if (this.addressValue.mobile.length >= this.number) {
        // this.hideKeyboard()
      }
    },
    regionClick: function() {
      if (this.pickerRegion.data.length > 0) {
        setTimeout(() => {
          this.$refs.pickerRegion.show()
        })
      } else {
        this.$toast("当前网络环境较差，请稍后再试");
      }
    },
    handlePickerConfirmRegion: function(v) {
      this.pickerRegion.anchor = v;
      var that = this;
      that.addressValue.addressid =
        that.pickerRegion.data[v[0].index].id +
        "," +
        that.pickerRegion.data[v[0].index].children[v[1].index].id +
        "," +
        that.pickerRegion.data[v[0].index].children[v[1].index].children[
          v[2].index
        ].id;
      that.addressValue.area = "";
      v.forEach(function(item, idx) {
        that.addressValue.area =
          that.addressValue.area === ""
            ? item.value
            : that.addressValue.area + "\n" + item.value;
      });
      console.log(that.addressValue.addressid);
      console.log(that.addressValue);
    },
    submit: function(typestr) {
      var arg = isApp();
      if (
        this.addressValue.name.replace(/ /g, "") == "" ||
        this.addressValue.name == undefined ||
        this.addressValue.name == null
      ) {
        this.$toast("收货人不能为空");
      } else if (
        this.addressValue.mobile.replace(/ /g, "") == "" ||
        this.addressValue.mobile == undefined ||
        this.addressValue.mobile == null
      ) {
        this.$toast("联系方式不能为空");
      } else if (
        this.addressValue.area.replace(/ /g, "") == "" ||
        this.addressValue.area == undefined ||
        this.addressValue.area == null
      ) {
        this.$toast("所在地区不能为空");
      } else if (
        this.addressValue.address.replace(/ /g, "") == "" ||
        this.addressValue.address == undefined ||
        this.addressValue.address == null
      ) {
        this.$toast("详细地址不能为空");
      } else {
        if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
          this.$toast("手机号码有误，请重填");
          return;
        }
        var func = () => {
          var url = this.$ajax.addAddress_URL;
          var data = {
            area: this.addressValue.area.split("\n").join(' '),
            address: this.addressValue.address,
            name: this.addressValue.name,
            mobile: this.addressValue.mobile,
            addressid: this.addressValue.addressid,
            isdefault: this.addressValue.isdefault
          };
          var that = this;
          function f (addressid) {
            var prizeurl = that.$ajax.addOrderByMeetingsPrizes_URL, prizedata = {
              addressid: addressid
            }
            that.$customRequestAjax.post(prizeurl, prizedata).then(res => {
              if (res.data.code == 200) {
                that.$dialog.alert({
                  message: res.data.msg,
                  className: 'percen_button_alert',
                  confirmButtonColor: '#FFFCFC',
                  confirmButtonText: '我知道了',
                  closeOnPopstate: false
                }).then(function () {
                  // on confirm
                  if (res.data.meetingid) {
                    window.location.replace('/static/wx/html/meeting/exclusive-gift.html?meetingid=' + res.data.meetingid)
                  } else {
                    that.$router.replace('/')
                  }
                })
              }
            })
          }
          if (that.addressid && that.$route.query.type == 'meeting') {
            f(that.addressid)
            return
          }
          that.$customRequestAjax.post(url, data).then(res => {
            if (res.data.code === 200) {
              var query = that.$route.query
              if (that.$route.query.type === "choose") {
                query.type = that.$route.query.ordertype
                if (that.$route.query.ordertype == 'submitcollageorder'
                  || that.$route.query.ordertype == 'submitjoincollageorder'
                  || that.$route.query.ordertype == 'submsjkjorder'
                  || that.$route.query.ordertype == 'submitfporder') {
                  that.$router.replace({path: "/addresschoose?1=1" + arg,
                    query: query
                  });
                } else {
                  that.$router.replace({path: "/addresschoose",
                    query: query
                  });
                }
              } else if (that.$route.query.type === "admin") {
                that.$router.replace("/addmana");
              } else if (that.$route.query.type === "addorder") {
                switch (that.$route.query.ordertype) {
                  case "submitorder":
                    query.chooseid = 0
                    query.addressid = res.data.addressid
                    that.$router.replace({
                      path: "/order",
                      query: query
                    });
                    break;
                  case "submitcollageorder":
                    window.location.replace(
                      "/static/wx/html/new-group/collage_order.html?ptid=" +
                      that.$route.query.gid +
                      "&code=" +
                      that.$route.query.code +
                      "&addressid=" +
                      res.data.addressid +
                      arg
                    );
                    break;
                  case "submitjoincollageorder":
                    window.location.replace(
                      "/static/wx/html/new-group/joincollage_order.html?gid=" +
                      that.$route.query.gid +
                      "&code=" +
                      that.$route.query.code +
                      "&addressid=" +
                      res.data.addressid +
                      arg
                    );
                    break;
                  case "submitfporder":
                    window.location.replace(
                      "/static/wx/html/actorder.html?actid=" +
                      that.$route.query.actid +
                      "&addressid=" +
                      res.data.addressid +
                      arg
                    );
                    break;
                  case "submitfortynineorder":
                    window.location.replace(
                      "/static/wx/html/499/actorder.html?actid=" +
                      that.$route.query.actid +
                      "&addressid=" +
                      res.data.addressid +
                      arg
                    );
                    break;
                  case "submitIntegral":
                    query.chooseid = 0
                    query.addressid = res.data.addressid
                    that.$router.replace({
                      path: "/addOrderIntegral",
                      query: query
                    });
                    break;
                }
              } else if (that.$route.query.type == 'meeting') {
                that.addressid = res.data.addressid
                f(res.data.addressid)
              }
            }
          }).catch(err => {
            that.address_for()
          });
        }

        if (typestr == 'update_area') {
          func()
        } else {
          this.discern(null, this.addressValue.address, (res) => {
            if (res != null) {
              let area = []
              if (this.addressValue.area.indexOf('\n') >= 0)
              { area = this.addressValue.area.split("\n") }
              else
              { area = this.addressValue.area.split(" ") }
              console.log(area, this.addressValue.addressid)
              if ((area.length == 3 && (area[0] != res.data.province || area[1] != res.data.city))
                ||(area.length == 1 && area[0].indexOf(res.data.province+res.data.city) < 0)) {
                this.areatemp = res.data.province + ' ' + res.data.city + ' ' + res.data.county
                this.areaidtemp = res.data.province_code + "," + res.data.city_code + ',' + res.data.county_code
                this.discernshow = true
              } else {
                this.areatemp = ''
                this.areaidtemp = ''
                this.discernshow = false
                func()
              }
            } else {
              func()
            }

          })
        }
      }
    },
    notUpdateHandle () {
      this.submit('update_area')
    },
    updateHandle () {
      this.addressValue.area = this.areatemp
      this.addressValue.addressid = this.areaidtemp
      this.submit('update_area')
    },
    address_for () {
      var that = this
      let area = []
      if (that.addressValue.area.indexOf('\n') >= 0)
        { area = that.addressValue.area.split("\n") }
      else
        { area = that.addressValue.area.split(" ") }
      let regionData = that.pickerRegion.data
      that.regionShow = false
      that.pickerRegion.data = []
      let anchor = []
      if (area.length > 0) {
        if (!anchor.length) {
          for (let i = 0; i < regionData.length; i++) {
            if (!area[0]) {
              break;
            } else if (regionData[i].value == area[0]) {
              anchor.push({
                index: i,
                value: regionData[i].value
              })
              break;
            }
          }
          if (anchor.length == 0) {
            anchor.push({
              index: 0,
              value: regionData[0].value
            })
          }
        }
        if (anchor.length) {
          let childData_1 = regionData[anchor[0].index].children
          for (let i = 0; i < childData_1.length; i++) {
            if (!area[1]) {
              break;
            } else if (childData_1[i].value == area[1]) {
              anchor.push({
                index: i,
                value: childData_1[i].value
              })
              break;
            }
          }
          if (anchor.length == 1) {
            anchor.push({
              index: 0,
              value: childData_1[0].value
            })
          }
        }
        if (anchor.length > 1) {
          let childData_2 = regionData[anchor[0].index].children[anchor[1].index].children
          for (let i = 0; i < childData_2.length; i++) {
            if (!area[2]) {
              break;
            } else if (childData_2[i].value == area[2]) {
              anchor.push({
                index: i,
                value: childData_2[i].value
              })
              break;
            }
          }
          if (anchor.length == 2) {
            anchor.push({
              index: 0,
              value: childData_2[0].value
            })
          }
        }
      }
      that.pickerRegion.anchor = anchor
      that.pickerRegion.data = regionData
      setTimeout(() => {
        that.regionShow = true
        that.$toast('省市区信息不合法')
        that.regionClick()
      })
    },
    input_blur() {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight, 0));
      }, 100);
    },
    handlechange(n) {
      var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.addressValue[n].match(reg)) {
        this.addressValue[n] = this.addressValue[n].replace(reg, "");
      }
      this.addressValue[n] = this.addressValue[n].replace(/\s+/g, "");
    },
    discern(num, site, callback) {
      let that = this;
      let url = "";
      let func = () => {
        url = this.$ajax.initAddress_URL+"?text=" + site;
        this.$customRequestAjax(url).then(res => {
          // that.$toast("识别成功");
          if (res != null && res.data.code == 200) {
            if (num != null) {
              if ((res.data.person && num != 2) || num == 2) that.addressValue.name = res.data.person;
              if ((res.data.phonenum && num != 2) || num == 2) that.addressValue.mobile = parseInt(res.data.phonenum);
              if ((res.data.phonenum && num != 2) || num == 2) that.mobile = parseInt(res.data.phonenum);
              that.addressValue.area =
                res.data.province + ' ' + res.data.city + ' ' + res.data.county;
              that.addressValue.addressid =
                res.data.province_code +
                "," +
                res.data.city_code +
                "," +
                res.data.county_code;
              that.addressValue.address = res.data.town + res.data.detail;
              that.sitepcq =
                res.data.province + ' ' + res.data.city + ' ' + res.data.county + ' ' + res.data.town;
              that.siteAddress = res.data.detail;
            }
            if (typeof callback == 'function') callback(res)
          } else {
            if (typeof callback == 'function') callback(null)
          }
        });
      }
      if (num == null) {
        discernFunc(site, () => {
          func()
        }, () => {
          if (typeof callback == 'function') callback(null)
        })
      } else {
        func()
      }
    },
    clearSmart() {
      this.smartTxt = "";
    },
    addressDetail() {
      this.showMap = true;
    },
    startSite() {
      console.log("weiixn执行");
      let self = this;
      // self.addressDetail();
      wx.getLocation({
        type: "wgs84", // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
        success: function(res) {
          var latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
          var longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
          var speed = res.speed; // 速度，以米/每秒计
          var accuracy = res.accuracy; // 位置精度
          console.log("resweiixn====", res);
          self.latVal = latitude;
          self.lngVal = longitude;
          self.addressDetail();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.editAdd {
  background: #f5f5f5;
  >img {
    width: 100%;
  }
  .top_map {
    background: #ffffff;
    padding-top: 0.13rem;
    .top_div {
      display: flex;
      -webkit-box-orient: horizontal;
      -webkit-box-direction: normal;
      -ms-flex-direction: row;
      flex-direction: row;
      -webkit-box-pack: end;
      -ms-flex-pack: end;
      justify-content: space-between;
      flex-wrap: nowrap;
      background: #f5f5f5;
      border-radius: 0.08rem;
      width: 94%;
      margin: 0 auto;
      padding: 0.12rem 0.1rem;
      .lf_txt {
        font-size: 0.14rem;
        font-weight: bold;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        line-height: 0.28rem;
        img {
          height: 0.18rem;
          width: 0.18rem;
          margin-top: 0.05rem;
          margin-right: 0.03rem;
        }
      }
      .btn_top {
        width: 0.95rem;
        height: 0.28rem;
        font-size: 0.14rem;
        line-height: 0.28rem;
        border: 0;
        outline: none;
        border-radius: 0.25rem;
        display: block;
        border: 1px solid;
        color: #f82e57;
        background: #f5f5f5;
      }
    }
  }
  ul {
    padding: 0 0.1rem 0 0.15rem;
    background: #fff;
    li {
      display: flex;
      display: -webkit-flex;
      display: -o-flex;
      display: -ms-flex;
      display: -moz-flex;
      align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      -ms-align-items: center;
      -moz-align-items: center;
      height: 0.45rem;
      border-bottom: 0.01rem solid #d8d8d8;
      &:nth-of-type(3) {
        // justify-content: space-between;
        // -webkit-justify-content: space-between;
        // -o-justify-content: space-between;
        // -ms-justify-content: space-between;
        // -moz-justify-content: space-between;
        position: relative;
        div {
          span {
            font-size: 0.13rem;
            color: #999999;
            float: left;
          }
        }
        img {
          width: 8px;
          position: absolute;
          right: 2px;
          top: 17px;
        }
      }
      &:last-of-type {
        display: flex;
        height: auto;
        border-bottom: none;
        padding-bottom: 0.1rem;
        padding-top: 0.12rem;
        textarea {
          display: block;
          width: 75%;
          height: 0.63rem;
          margin-top: 0.04rem;
          border: none;
          outline: none;
          font-size: 0.14rem;
          color: #444;
          &::placeholder {
            color: #b7b7b7;
            font-size: 0.14rem;
          }
        }
      }
      p {
        font-size: 0.14rem;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        line-height: 0.2rem;
        width: 0.82rem;
      }
      input {
        border: none;
        outline: none;
        display: block;
        font-size: 0.14rem;
        color: #333;
        &::placeholder {
          color: #b7b7b7;
          font-size: 0.14rem;
        }
      }
    }
  }
  .bottom_div {
    margin-top: 8px;
    background: #ffffff;
    textarea {
      display: block;
      width: 100%;
      height: 0.63rem;
      padding: 12px 15px;
      border: none;
      outline: none;
      font-size: 0.14rem;
      color: #444;
      &::placeholder {
        color: #b7b7b7;
        font-size: 0.14rem;
      }
    }
    .btn_div {
      background: #ffffff;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      flex-wrap: nowrap;
      padding: 20px 15px 12px 0px;
      .btn_rt1 {
        width: 80px;
        height: 28px;
        text-align: center;
        font-size: 14px;
        line-height: 28px;
        border: 0;
        outline: none;
      }
      .btn_rt2 {
        width: 80px;
        height: 28px;
        font-size: 14px;
        line-height: 28px;
        border: 0;
        outline: none;
        border-radius: 0.25rem;
        display: block;
        color: #ffffff;
        background: #dddddd;
      }
      .btn_rt3 {
        width: 80px;
        height: 28px;
        font-size: 14px;
        line-height: 28px;
        border: 0;
        outline: none;
        border-radius: 0.25rem;
        display: block;
        color: #ffffff;
        background: linear-gradient(90deg, #fc0324, #f63a66);
      }
    }
  }
  footer {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 0.1rem 0.11rem;
    button {
      height: 0.43rem;
      margin-bottom: 0.1rem;
    }
    .btn.btn_dis {
      background: #dddddd;
    }
    .btn {
      border: 0;
      outline: none;
      border-radius: 0.25rem;
      display: block;
      font-size: 0.17rem;
      color: #ffffff;
      width: 100%;
      background: linear-gradient(90deg, #fc0324, #f63a66);
      background: -webkit-linear-gradient(90deg, #fc0324, #f63a66);
      background: -o-linear-gradient(90deg, #fc0324, #f63a66);
      background: -moz-linear-gradient(90deg, #fc0324, #f63a66);
      background: -ms-linear-gradient(90deg, #fc0324, #f63a66);
    }
  }
  .collect_button_alert.van-dialog {
    width: 85%;
  }
  .discern {
    padding: 0 0.34rem;
    p {
      margin-top: 0.08rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/addAddress.vue